export default __webpack_public_path__ + "static/media/cluster_point_asphalt.157a035d.svg";